import React, { useState } from "react";

interface SupportPageProps {
  onNavigateBack: () => void;
}

const SupportPage: React.FC<SupportPageProps> = ({ onNavigateBack }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    topic: "",
    description: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.topic) {
      alert("Please fill in required fields");
      return;
    }
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setSuccess(true);
    }, 2000);
  };

  if (success) {
    return (
      <div className="support-success">
        <h1>Support Ticket Submitted</h1>
        <p>Ticket ID: {Math.floor(Math.random() * 10000)}</p>
        <button onClick={onNavigateBack}>Back to Calculator</button>
      </div>
    );
  }

  return (
    <div className="support-container">
      <h1>Support Ticket Form</h1>
      <form className="support-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name <span>*</span></label>
          <div className="name-fields">
            <input
              type="text"
              name="firstName"
              placeholder="First"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last"
              value={formData.lastName}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Email <span>*</span></label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Topic <span>*</span></label>
          <select
            name="topic"
            value={formData.topic}
            onChange={handleInputChange}
            required
          >
            <option value="">What can we help you with today?</option>
            <option value="General">General</option>
            <option value="Bug">Bug</option>
          </select>
        </div>

        <div className="form-group">
          <label>Description (optional)</label>
          <textarea
            name="description"
            placeholder="Description Report"
            value={formData.description}
            onChange={handleInputChange}
          />
        </div>

        <button type="submit" className="submit-btn" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "SEND"}
        </button>
      </form>
    </div>
  );
};

export default SupportPage;
